import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import _isEmpty from "lodash.isempty";
import _get from "lodash.get";
import Icon from "../../../shared_modules/common/icons/Icon";

// msg types: 'none', 'info', 'error', 'success'

class ValidationMsg extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      info: [],
      numMsgs: 0,
      numErrors: 0,
      numInfo: 0,
    };
  }

  static defaultProps = {
    msgs: [],
    filterFields: [],
    who: "",
    tooltip: false,
  };

  renderRowValSingle(details, numE, numI) {
    // display priority given to info,
    // since they occur onFocus (immediate),
    // data values are checked for validity onBlur (when done typing)
    const item = numI > 0 ? details.info.data[0] : details.errors.data[0],
      { type, msg } = item,
      { tooltip } = this.props,
      msgClasses = classnames({
        msg: true,
        [`type-${type}`]: true,
      }),
      showToolTip = tooltip,
      toolTipLines2 = showToolTip && msg.length > 65 && msg.length < 120,
      toolTipLines3 = showToolTip && msg.length > 120;

    const nonErrorMsgClasses = classnames({
      "msg-list-item": true,
      "tool-tip": showToolTip,
      "lines-2": toolTipLines2,
      "lines-3": toolTipLines3,
    });

    return (
      <div className={msgClasses}>
        {type === "error" ? (
          <label className="msg-list-item" role="alert" aria-invalid={true}>
            <Icon type="error" />
            <span className="text">{msg}</span>
          </label>
        ) : (
          <span className={nonErrorMsgClasses}>
            <span className="text">{msg}</span>
          </span>
        )}
      </div>
    );
  }

  renderRowValMulti(details, numE, numI) {
    // display priority given to info (onFocus), then errors (onBlur)
    let items,
      type,
      msgClasses,
      nonErrorMsgClasses,
      showToolTip,
      toolTipLines2,
      toolTipLines3;
    const { tooltip } = this.props;

    if (numI > 0) {
      items = details.info.data;
      type = "info";
    } else {
      items = details.errors.data;
      type = "error";
    }

    msgClasses = classnames({
      msgs: true,
      [`type-${type}`]: true,
      [`msgs-num-${items.length}`]: true,
    });

    return (
      <div className={msgClasses}>
        {type === "error" && <Icon type="error" />}
        <ol className="msg-list">
          {items.map((item, idx) => {
            const { id, type, msg } = item;
            showToolTip = tooltip && items.length === 1;
            toolTipLines2 = showToolTip && msg.length > 65 && msg.length < 120;
            toolTipLines3 = showToolTip && msg.length > 120;

            nonErrorMsgClasses = classnames({
              "msg-list-item": true,
              "tool-tip": showToolTip,
              "lines-2": toolTipLines2,
              "lines-3": toolTipLines3,
            });

            return (
              <li className={nonErrorMsgClasses} key={idx}>
                {type === "error" ? (
                  <label htmlFor={id} role="alert" aria-invalid={true}>
                    {msg}
                  </label>
                ) : (
                  <span className="text">{msg}</span>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    );
  }

  renderEmpty() {
    return <div className="msg msg-none" />;
  }

  // determine if there are messages to display (ie. errors, info)
  findDisplayData() {
    const { msgs, filterFields } = this.props;
    let container = {},
      msgKeys = Object.keys(msgs);

    container.keys = msgKeys;

    msgKeys.map((key) => {
      container[key] = { count: 0, data: [] }; // initialize

      filterFields.map((field) => {
        let obj = msgs[key][field] || {},
          { msg, type } = msgs[key][field];

        if (!_isEmpty(obj) && msg && type) {
          container[key].count += 1;
          container[key].data.push(obj);
        }
      });
    });
    return container;
  }

  render() {
    const details = this.findDisplayData(),
      numErrors = _get(details, "errors.count", 0),
      numInfo = _get(details, "info.count", 0);

    if (numErrors >= 2 || numInfo >= 2) {
      return this.renderRowValMulti(details, numErrors, numInfo);
    }
    if (numErrors >= 1 || numInfo >= 1) {
      return this.renderRowValSingle(details, numErrors, numInfo);
    }
    return this.renderEmpty();
  }
}

ValidationMsg.propTypes = {
  msgs: PropTypes.object,
  who: PropTypes.string,
  filterFields: PropTypes.array,
  tooltip: PropTypes.bool,
};

export default ValidationMsg;

